export enum UnitOfMeasurement {
  METER = 'METER',
  PIECES = 'PIECES'
}
